import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    carousals: [],
    apiError: ''
}
export const carousalSlice = createSlice({
    name: 'carousal',
    initialState,
    reducers: {
        setCarousals: (state, action) => {
            state.carousals = action.payload.data;
        },
        setApiError: (state, action) => {
            state.apiError = action.payload.apiError;
        }
    }
})

export const { setCarousals, setApiError } = carousalSlice.actions
export default carousalSlice.reducer